<template>
  <div style="text-align: center">
    <a-icon type="warning" style="font-size: 186px" />
    <div
      style="
        font-size: 56px;
        color: #595959;
        font-weight: 500;
        margin-top: 20px;
      "
    >
      NÖQSAN TAPILMADI
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFoundProblem",
};
</script>
